import { ElementRef, Injector, Component, OnInit,  Input, HostListener  } from '@angular/core';
import { BaseComponent } from '../../base.component';

@Component({
    selector: 'click-list-item',
    host: { '[class]': 'myCustomClass' },
    template: `
    <div gtm-handler events="click" handlerType="multiValue" label="Get a Quote" value=control.name  [dataVal]=control.name action="ButtonClick" >
    <hr />
    <div class="click-list-lineup">
        <img [src]="control.attributes.imageUrl" [attr.alt]="control.name" />
        <ul>
            <li *ngFor="let text of control.attributes.texts">
                {{text}}
            </li> 
        </ul>
        <a href="{{ control.attributes.url }}" tabindex="0" target="_blank">{{ control.attributes.label }}</a>
    </div>
</div>
    `,
styleUrls: ['./click-list-item.component.scss']
})

export class ClickListItemComponent extends BaseComponent implements OnInit {

    constructor(injector: Injector) {
    super(injector);
    }

    ngOnInit() {

    }

}
